import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  crearClaseDeSuelo,
  darDeBajaClaseDeSuelo,
  fetchClasesDeSuelo,
  guardarClaseDeSuelo,
  type ClaseDeSueloEditada,
  type ClaseDeSueloNueva,
} from "@/lib/suelos";

export const CLASES_DE_SUELO_KEY = ["suelo-clases"] as const;

/**
 * El catálogo de clases de uso de suelo.
 *
 * `staleTime` alto por lo mismo que la escala de homologación: cambia cuando
 * alguien lo corrige desde el mantenedor, no mientras se trabaja. La pestaña
 * "Descripción de suelos" lo consulta para llenar un selector por fila del
 * cuadro, y sin esto lo volvería a pedir en cada montaje.
 */
export function useClasesDeSuelo() {
  return useQuery({
    queryKey: CLASES_DE_SUELO_KEY,
    queryFn: fetchClasesDeSuelo,
    staleTime: 10 * 60 * 1000,
  });
}

export function useCrearClaseDeSuelo() {
  const cliente = useQueryClient();

  return useMutation({
    mutationFn: (datos: ClaseDeSueloNueva) => crearClaseDeSuelo(datos),
    onSuccess: () => {
      cliente.invalidateQueries({ queryKey: CLASES_DE_SUELO_KEY });
    },
  });
}

export function useGuardarClaseDeSuelo() {
  const cliente = useQueryClient();

  return useMutation({
    mutationFn: ({ id, cambios }: { id: number; cambios: ClaseDeSueloEditada }) =>
      guardarClaseDeSuelo(id, cambios),
    onSuccess: () => {
      cliente.invalidateQueries({ queryKey: CLASES_DE_SUELO_KEY });
    },
  });
}

export function useDarDeBajaClaseDeSuelo() {
  const cliente = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => darDeBajaClaseDeSuelo(id),
    onSuccess: () => {
      cliente.invalidateQueries({ queryKey: CLASES_DE_SUELO_KEY });
    },
  });
}
